export const MESSAGE_TYPE_INSTAGRAM_TOKEN = 'instagram-token'

export type InstagramTokenMessageData = {
  type: typeof MESSAGE_TYPE_INSTAGRAM_TOKEN
  token: string
}

export const INSTAGRAM_AUTH_CHANNEL_NAME = 'instagram-auth'
